import React, { useState } from 'react';
interface PricingOption {
  id: string;
  emoji: string;
  title: string;
  description: string;
  originalPrice: string;
  price: string;
  ctaText: string;
  ctaHref: string;
  isFeatured?: boolean;
  savings?: string;
}
const options: PricingOption[] = [{
  id: 'primaria',
  emoji: '📘',
  title: 'PRIMARIA',
  description: '6 tomos + 120 clases + bonos',
  originalPrice: '$53.000',
  price: '$16.990',
  ctaText: 'SÍ, QUIERO PRIMARIA →',
  ctaHref: 'https://www.profepack.com/cart/48115364167936:1'
}, {
  id: 'completo',
  emoji: '🏆',
  title: 'PACK COMPLETO',
  description: '12 tomos + 240 clases + bonos',
  originalPrice: '$35.980',
  price: '$27.990',
  ctaText: 'SÍ, QUIERO PACK COMPLETO →',
  ctaHref: 'https://www.profepack.com/cart/48097187004672:1',
  isFeatured: true,
  savings: 'AHORRÁS $7.990'
}, {
  id: 'secundaria',
  emoji: '📗',
  title: 'SECUNDARIA',
  description: '6 tomos + 120 clases + bonos',
  originalPrice: '$53.000',
  price: '$18.990',
  ctaText: 'SÍ, QUIERO SECUNDARIA →',
  ctaHref: 'https://www.profepack.com/cart/48115364626688:1'
}];
export function PricingSection() {
  const [selected, setSelected] = useState('completo');
  const selectedOption = options.find(o => o.id === selected)!;
  return <section id="pricing" className="w-full bg-[#111111] py-10 sm:py-16 px-4" data-id="element-151">
      <div className="max-w-xl mx-auto" data-id="element-152">
        <h2 className="text-2xl sm:text-4xl font-black text-white text-center mb-1 sm:mb-3" data-id="element-153">
          Elegí tu <span className="text-[#33BFA6]" data-id="element-154">PROFEPACK:</span>
        </h2>
        <p className="text-gray-300 text-center text-xs sm:text-base mb-5 sm:mb-10" data-id="element-155">
          Todas las opciones incluyen los 6 bonos estratégicos
        </p>

        <div className="space-y-3 sm:space-y-4 mb-5 sm:mb-8" data-id="element-156">
          {options.map(option => {
          const isSelected = selected === option.id;
          const isFeatured = option.isFeatured;
          return <button key={option.id} onClick={() => setSelected(option.id)} className={`w-full text-left rounded-xl sm:rounded-2xl p-4 sm:p-6 transition-all ${isSelected ? 'border-2 border-[#33BFA6] shadow-[0_0_30px_rgba(51,191,166,0.15)]' : 'border border-white/10'} ${isFeatured ? 'bg-[#0a100d]' : 'bg-[#0a0a0a]'}`} data-id="element-157">
                <div className="flex items-center gap-3 sm:gap-4" data-id="element-158">
                  <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${isSelected ? 'border-[#33BFA6]' : 'border-white/30'}`} data-id="element-159">
                    {isSelected && <div className="w-3 h-3 rounded-full bg-[#33BFA6]" data-id="element-160" />}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-161">
                    <div className="flex items-center gap-2 flex-wrap" data-id="element-162">
                      <span className="text-lg" data-id="element-163">{option.emoji}</span>
                      <span className="text-white font-black text-base sm:text-lg" data-id="element-164">
                        {option.title}
                      </span>
                    </div>

                    {/* Badges */}
                    {isFeatured && <div className="flex items-center gap-2 mt-1.5 sm:mt-2 flex-wrap" data-id="element-165">
                        <span className="bg-[#33BFA6] text-gray-900 text-[11px] sm:text-xs font-black px-2.5 sm:px-3 py-0.5 sm:py-1 rounded-full" data-id="element-166">
                          ⭐ MÁS ELEGIDO
                        </span>
                        {option.savings && <span className="bg-white/10 text-[#33BFA6] text-[11px] sm:text-xs font-bold px-2.5 sm:px-3 py-0.5 sm:py-1 rounded-full border border-white/30" data-id="element-167">
                            {option.savings}
                          </span>}
                      </div>}

                    <p className="text-gray-400 text-sm mt-1" data-id="element-168">
                      {option.description}
                    </p>
                  </div>

                  {/* Price */}
                  <div className="text-right flex-shrink-0" data-id="element-169">
                    <div className="text-gray-400 line-through text-xs sm:text-sm" data-id="element-170">
                      {option.originalPrice}
                    </div>
                    <div className={`font-black text-2xl sm:text-3xl ${isFeatured ? 'text-[#33BFA6]' : 'text-white'}`} data-id="element-171">
                      {option.price}
                    </div>
                  </div>
                </div>
              </button>;
        })}
        </div>

        <a href={selectedOption.ctaHref} className="btn-bordo-pulse block w-full text-center bg-[#33BFA6] text-gray-900 font-black text-base sm:text-xl py-4 sm:py-5 rounded-xl sm:rounded-2xl hover:bg-[#2AA890] transition-colors" data-id="element-172">
          {selectedOption.ctaText}
        </a>

        <p className="text-gray-400 text-xs sm:text-sm text-center mt-3 sm:mt-4 italic" data-id="element-173">
          {selected === 'completo' ? 'La opción más elegida por docentes que enseñan en los dos niveles' : selected === 'primaria' ? 'Ideal para docentes de Lengua y Literatura de primaria (1° a 6° grado)' : 'Ideal para docentes de Lengua y Literatura de secundaria (1° a 6° año)'}
        </p>

        <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-4 text-xs sm:text-sm text-gray-300 mt-6 sm:mt-8 bg-[#0a0a0a] border border-white/10 rounded-xl py-3 sm:py-4 px-4 sm:px-6" data-id="element-174">
          <span data-id="element-175">🔒 Pago seguro</span>
          <span data-id="element-176">⚡ Acceso en 5 min</span>
          <span data-id="element-177">🛡️ Garantía 7 días</span>
          <span data-id="element-178">💳 Mercado Pago</span>
        </div>
      </div>
    </section>;
}